import { render, staticRenderFns } from "./content-type.vue?vue&type=template&id=342d7cf6"
import script from "./content-type.vue?vue&type=script&lang=js"
export * from "./content-type.vue?vue&type=script&lang=js"
import style0 from "./content-type.vue?vue&type=style&index=0&id=342d7cf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports